<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-space-between>
      <v-flex xs12 sm2>
        <v-btn
          color="primary"
          @click="create"
          class="mb-4"
          :disabled="!hasCondominioAccess(entity, 'create')"
        >
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-layout justify-space-between align-left>
          <v-text-field
            append-icon="search" 
            label="Pesquisar"
            v-model="search"
            @keyup.native="keyupSearch"
          ></v-text-field>
          <v-checkbox label="Apenas Ativos" v-model="apenasAtivos" @change="initialize()"/>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm1>
        <v-menu offset-y>
          <v-btn slot="activator" icon class="ml-2" title="Relatórios">
            <v-icon>description</v-icon>
          </v-btn>
          <v-list>
            <!-- PDF -->
            <v-list-tile @click="exportReport(1)">
              <v-list-tile-action>
                <v-icon color="red darken-1">picture_as_pdf</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Relatório em PDF</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <!-- Excel -->
            <v-list-tile @click="exportReport(2)">
              <v-list-tile-action>
                <v-icon color="green darken-2">table_chart</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Relatório em Excel</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          disable-initial-sort
          :pagination.sync="pagination"
          hide-actions
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.sequencia_ir }}</td>
            <td>{{ props.item.id_texto }}</td>
            <td>{{ getGrupoText(props.item.grupo) }}</td>
            <td>{{ getCodigoText(props.item.grupo, props.item.codigo) }}</td>
            <!--<td>{{ props.item.codigo ? translate('value.bem_direito_codigo').filter(a=>a.value == props.item.codigo)[0].text : ' '}}</td>-->
            <td class="text-xs-right">
              {{ props.item.situacao_anoanterior | formatCurrency }}
            </td>
            <td class="text-xs-right">
              {{ props.item.situacao_anobase | formatCurrency }}
            </td>
            <td>
              <v-checkbox
                v-model="props.item.ativo"
                color="primary"
                @click.native="
                  editValue(entity, props.item.id, {
                    id: props.item['id'],
                    ativo: props.item['ativo'],
                  })
                "
              ></v-checkbox>
            </td>
            <td align="center">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'delete')"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:footer>
            <td colspan="4">
              <strong>Total Geral</strong>
            </td>
            <td align="right">
              <strong>{{ total_situacao_anoanterior | formatCurrency }}</strong>
            </td>
            <td align="right">
              <strong>{{ total_situacao_anobase | formatCurrency }}</strong>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
        <div
          style="
            border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
            border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
            border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
          "
          class="v-datatable v-table theme--light"
        >
          <div class="v-datatable__actions">
            <div class="v-datatable__actions__select">
              Registros por página
              <v-select
                :items="[25, 50, 75, 100]"
                @change="changePage(pagination['current_page'])"
                v-model="pagination['rowsPerPage']"
                class="v-select__selection v-select__selection--comma"
              ></v-select>
              <!-- <input aria-label="Registros por página" readonly="readonly" type="text" autocomplete="on" aria-readonly="false"> -->
            </div>
            <div class="v-datatable__actions__range-controls">
              <div class="v-datatable__actions__pagination">
                {{ `${this.pagination.from} - ${this.pagination.to} de ${this.pagination.total}` }}
              </div>
              <button
                :disabled="pagination['current_page'] === 1"
                @click="changePage(pagination['current_page'] - 1)"
                type="button"
                :class="
                  pagination['current_page'] === 1
                    ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                    : 'v-btn v-btn--flat v-btn--icon theme--light'
                "
                aria-label="Previous page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i>
                </div>
              </button>
              <button
                :disabled="pagination['current_page'] === pagination.last_page"
                @click="changePage(pagination['current_page'] + 1)"
                type="button"
                :class="
                  pagination['current_page'] === pagination.last_page
                    ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                    : 'v-btn v-btn--flat v-btn--icon theme--light'
                "
                aria-label="Next page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-space-between align-center>
              <v-flex xs12 md6>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>

              <v-spacer></v-spacer>

              <v-flex xs12 md4>
                <v-checkbox
                  class="m-0"
                  v-model="limitarCaracteres"
                  label="Limitar a quantidade de caracteres"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <v-text-field
                  name="id_texto"
                  :label="translate('table.' + entity + '.field.id_texto')"
                  :maxlength="limitarCaracteres ? 150 : 512"
                  counter
                  data-vv-validate-on="blur"
                  v-model="editedItem.id_texto"
                  v-validate="'required' + (limitarCaracteres ? '|max:150' : '|max:512')"
                  :error-messages="errors.collect('id_texto')"
                  :data-vv-as="translate('table.' + entity + '.field.id_texto')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md2>
                <v-autocomplete
                  name="grupo"
                  :label="translate('table.' + entity + '.field.grupo')"
                  v-model="editedItem.grupo"
                  @change="editedItem.codigo = null"
                  :items="translate('value.bem_direito_grupo')"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('grupo')"
                  :data-vv-as="translate('table.' + entity + '.field.grupo')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md2>
                <v-autocomplete
                  name="codigo"
                  :items="
                    translate('value.bem_direito_codigo').filter(
                      (item) => item['grupo'] === editedItem.grupo
                    )
                  "
                  :label="translate('table.' + entity + '.field.codigo')"
                  v-model="editedItem.codigo"
                  data-vv-validate-on="blur"
                  @change="editedItem.iptu_nirf = null"
                  v-validate="'required'"
                  :error-messages="errors.collect('codigo')"
                  :data-vv-as="translate('table.' + entity + '.field.codigo')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  name="sequencia_ir"
                  data-vv-validate-on="blur"
                  counter
                  maxlength="19"
                  v-model="editedItem.sequencia_ir"
                  v-validate="'required'"
                  @blur="checkDuplicate(items, 'sequencia_ir', editedItem.sequencia_ir)"
                  :error-messages="errors.collect('sequencia_ir')"
                  :data-vv-as="translate('table.' + entity + '.field.sequencia_ir')"
                  :label="translate('table.' + entity + '.field.sequencia_ir')"
                ></v-text-field>
                <div
                  style="color: #ff5252; font-size: 12px !important; position: relative; margin-top: -20px"
                  v-if="sequencia_ir_duplicated"
                >
                  Este valor já foi inserido anteriormente.
                </div>
              </v-flex>
              <v-flex xs12 md3>
                <v-autocomplete
                  name="pais_id"
                  v-model="editedItem.pais_id"
                  :items="paises"
                  item-text="id_texto"
                  item-value="id"
                  single-line
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('pais_id')"
                  :data-vv-as="translate('table.' + entity + '.field.pais_id')"
                  :label="translate('table.' + entity + '.field.pais_id')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <p-date
                  name="data"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('data')"
                  :data-vv-as="translate('table.' + entity + '.field.data')"
                  :label="translate('table.' + entity + '.field.data')"
                  v-model="editedItem.data"
                ></p-date>
              </v-flex>

              <v-container class="pa-0" fluid>
                <v-layout
                  wrap
                  v-if="
                    [
                      '1-1',
                      '1-2',
                      '1-3',
                      '1-11',
                      '1-12',
                      '1-13',
                      '1-14',
                      '1-15',
                      '1-18',
                      '1-19',
                      '1-99',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12>
                    <v-text-field
                      :label="
                        ['1-14'].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                          ? 'NIRF'
                          : 'Inscrição Municipal (IPTU)'
                      "
                      v-model="editedItem.iptu_nirf"
                      counter
                      :maxlength="['1-14'].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                          ? 8
                          : 30"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="['2-1', '2-2', '2-3'].includes(`${editedItem.grupo}-${editedItem.codigo}`)"
                >
                  <v-flex xs12>
                    <v-text-field
                      label="Registro"
                      v-model="editedItem.registro_veiculo"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout wrap v-if="['1-16'].includes(`${editedItem.grupo}-${editedItem.codigo}`)">
                  <v-flex xs12>
                    <v-text-field
                      :label="translate('table.' + entity + '.field.cei_cno')"
                      v-model="editedItem.cei_cno"
                      maxlength="12"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    [
                      '3-1',
                      '3-2',
                      '3-3',
                      '3-99',
                      '4-1',
                      '4-2',
                      '4-3',
                      '4-99',
                      '5-1',
                      '5-2',
                      '5-99',
                      '6-1',
                      '6-99',
                      '7-1',
                      '7-2',
                      '7-3',
                      '7-4',
                      '7-5',
                      '7-6',
                      '7-7',
                      '7-8',
                      '7-9',
                      '7-10',
                      '7-11',
                      '7-12',
                      '7-13',
                      '8-3',
                      '99-5',
                      '99-6',
                      '99-7',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12>
                    <p-cpf-cnpj v-model="editedItem.cpf_cnpj"></p-cpf-cnpj>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="['4-1', '6-1'].includes(`${editedItem.grupo}-${editedItem.codigo}`)"
                >
                  <v-flex xs12 md3>
                    <v-autocomplete
                      label="Banco"
                      v-model="editedItem.banco"
                      :items="translate('value.bem_direito_banco')"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field label="Agência" v-model="editedItem.agencia"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field label="Conta" v-model="editedItem.conta"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field label="DV" v-model="editedItem.dv"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    [
                      '1-1',
                      '1-2',
                      '1-3',
                      '1-11',
                      '1-12',
                      '1-13',
                      '1-14',
                      '1-15',
                      '1-16',
                      '1-17',
                      '1-18',
                      '1-19',
                      '1-99',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12 md8>
                    <v-text-field label="Logradouro" v-model="editedItem.logradouro"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field label="Número" v-model="editedItem.numero"></v-text-field>
                  </v-flex>

                  <v-flex xs12 md4>
                    <v-text-field
                      label="Complemento"
                      v-model="editedItem.complemento"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="Bairro / Distrito"
                      v-model="editedItem.bairro_distrito"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md4>
                    <v-autocomplete
                      label="Município"
                      v-model="editedItem.cidade_id"
                      :items="cidades"
                      item-text="id_texto"
                      item-value="id"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field label="CEP" v-model="editedItem.cep"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <p-money
                      label="Área Total do Imóvel"
                      v-model="editedItem.area_imovel"
                      custom_preffix=""
                      :custom_precision="1"
                    ></p-money>
                  </v-flex>
                  <v-flex xs12 md1>
                    <span id="unidade">
                      <p class="ma-0">Unidade</p>
                      <v-btn-toggle v-model="editedItem.unidade">
                        <v-btn flat value="m2">m²</v-btn>
                        <v-btn flat value="ha">ha</v-btn>
                      </v-btn-toggle>
                    </span>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    editedItem.pais_id == 105 &&
                    [
                      '1-1',
                      '1-2',
                      '1-3',
                      '1-11',
                      '1-12',
                      '1-13',
                      '1-14',
                      '1-15',
                      '1-18',
                      '1-19',
                      '1-99',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12 md3>
                    <v-switch
                      color="primary"
                      label="Registrado no Cartório"
                      v-model="editedItem.registrado_cartorio"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      label="Matrícula do Imóvel"
                      :disabled="!editedItem.registrado_cartorio"
                      v-model="editedItem.matricula_imovel"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      label="Nome do Cartório"
                      :disabled="!editedItem.registrado_cartorio"
                      v-model="editedItem.nome_cartorio"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    [
                      '1-1',
                      '1-2',
                      '1-3',
                      '1-11',
                      '1-12',
                      '1-13',
                      '1-14',
                      '1-15',
                      '1-18',
                      '1-19',
                      '1-99',
                      '2-1',
                      '2-2',
                      '2-3',
                      '99-1',
                      '99-2',
                      '99-3',
                      '99-4',
                      '99-5',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12 md6>
                    <p-cpf-cnpj
                      v-model="editedItem.cpf_cnpj_fornecedor"
                      label=" do Fornecedor"
                    ></p-cpf-cnpj>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      counter
                      maxlength="28"
                      label="Nome do Fornecedor"
                      v-model="editedItem.nome_fornecedor"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    [
                      '1-1',
                      '1-2',
                      '1-3',
                      '1-11',
                      '1-12',
                      '1-13',
                      '1-14',
                      '1-15',
                      '1-18',
                      '1-19',
                      '1-99',
                      '2-1',
                      '2-2',
                      '2-3',
                      '2-4',
                      '2-5',
                      '2-6',
                      '2-99',
                      '3-1',
                      '3-2',
                      '3-3',
                      '3-99',
                      '99-1',
                      '99-2',
                      '99-3',
                      '99-4',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12>
                    <p-money
                      name="valor_fornecedor"
                      label="Valor de Aquisicao"
                      v-model="editedItem.valor_fornecedor"
                      :v_validate="'positiveNumber'"
                    ></p-money>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    [
                      '1-1',
                      '1-2',
                      '1-3',
                      '1-11',
                      '1-12',
                      '1-13',
                      '1-14',
                      '1-15',
                      '1-16',
                      '1-17',
                      '1-18',
                      '1-19',
                      '1-99',
                      '2-1',
                      '2-2',
                      '2-3',
                      '2-4',
                      '2-5',
                      '2-6',
                      '2-99',
                      '3-1',
                      '3-2',
                      '3-3',
                      '3-99',
                      '99-1',
                      '99-2',
                      '99-3',
                      '99-4',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12 md2>
                    <v-autocomplete
                      label="Motivo da Baixa"
                      name="motivo_baixa"
                      v-model="editedItem.motivo_baixa"
                      :items="translate('value.bem_direito_motivo_baixa')"
                      data-vv-validate-on="blur"
                      v-validate="editedItem.cpf_cnpj_adquirente ? 'required' : ''"
                      :error-messages="errors.collect('motivo_baixa')"
                      data-vv-as="Motivo da Baixa"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md2>
                    <p-date
                      name="baixa"
                      label="Data da Baixa"
                      v-model="editedItem.baixa"
                      errors_collect="baixa"
                      data_vv_as="Data da Baixa"
                      :v_validate="editedItem.motivo_baixa ? 'required|currentYear:' + $auth.user().anobase.id_texto : ''"
                    ></p-date>
                  </v-flex>
                  <v-flex xs12 md3>
                    <p-cpf-cnpj
                      v-model="editedItem.cpf_cnpj_adquirente"
                      label=" do Adquirente"
                    ></p-cpf-cnpj>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      counter
                      maxlength="28"
                      label="Nome do Adquirente"
                      v-model="editedItem.nome_adquirente"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2>
                    <p-money
                      name="valor_adquirente"
                      label="Valor da Baixa/Venda"
                      v-model="editedItem.valor_adquirente"
                      :v_validate="'positiveNumber|requiredNumber'"
                      data_vv_as="Valor da Baixa/Venda"
                    ></p-money>
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  v-if="
                    temDependente &&
                    [
                      '3-1',
                      '3-2',
                      '3-3',
                      '3-99',
                      '4-1',
                      '4-2',
                      '5-99',
                      '6-1',
                      '6-9',
                      '7-3',
                      '7-5',
                      '7-6',
                      '7-99',
                      '8-1',
                      '8-2',
                      '8-10',
                      '99-5',
                      '99-6',
                      '99-8',
                      '99-99',
                    ].includes(`${editedItem.grupo}-${editedItem.codigo}`)
                  "
                >
                  <v-flex xs12>
                    <v-autocomplete
                      :label="translate('table.' + entity + '.field.pessoa_dependente_id')"
                      v-model="editedItem.pessoa_dependente_id"
                      :items="dependente_items"
                      item-text="id_texto"
                      item-value="id"
                    ></v-autocomplete>
                  </v-flex>                
                </v-layout>

                <v-layout v-if="['3-1'].includes(`${editedItem.grupo}-${editedItem.codigo}`)">
                  <v-flex xs12 md4>
                    <v-checkbox
                      class="m-0"
                      v-model="editedItem.negociacao_bolsa"
                      label="Negociados em Bolsa?"
                    ></v-checkbox>
                  </v-flex>
                </v-layout> 
              </v-container>

              <!--INICIO------------------- Distribuição ------------------->
              <v-flex xs12 md8>
                <span class="headline">Distribuições</span>
              </v-flex>
              <v-flex xs12 md4 class="text-xs-right">
                <v-btn color="primary" @click="createSubItem()" class="my-1">
                  {{ this.translate("system.button.add.title") }}
                  <v-icon dark>
                    {{ this.translate("system.button.add.icon") }}
                  </v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="sub_headers"
                  :items="editedItem.sub_items"
                  id="sub_items_table"
                  hide-actions
                  no-data-text="Não existem registros"
                  no-results-text="Nenhum registro encontrado"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <v-autocomplete
                        v-model="props.item.tipo"
                        :items="subItemTipos"
                        item-text="id_texto"
                        item-value="id"
                        name="tipo"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <p-date
                        limitPreviousYears
                        v-model="props.item.data"
                        name="data"
                        counter
                        maxlength="8"
                        data-vv-validate-on="blur"
                        :error-messages="errors.collect('tipo')"
                        :data-vv-as="translate('table.' + entity + '.field.tipo')"
                        :label="translate('table.' + entity + '.field.tipo')"
                      ></p-date>
                    </td>
                    <td>
                      <p-money
                        name="valor"
                        v-model="props.item.valor"
                        :v_validate="'positiveNumber'"
                        data_vv_as="Valor"
                      ></p-money>
                    </td>
                    <td align="center">
                      <v-btn icon class="mx-0" @click="deleteSubItem(props.item)">
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12 md3>
                <p-money
                  disabled
                  :label="translate('table.' + entity + '.field.valor_pago')"
                  :value="sum.pagamento"
                ></p-money>
              </v-flex>
              <v-flex xs12 md3>
                <p-money
                  disabled
                  :label="translate('table.' + entity + '.field.valor_liberado')"
                  :value="sum.liberacao"
                ></p-money>
              </v-flex>
              <v-flex xs12 md3>
                <p-money
                  disabled
                  name="situacao_anoanterior"
                  :label="
                    translate('table.' + entity + '.field.situacao_anoanterior') +
                    ($auth.user().anobase.id_texto - 1)
                  "
                  v-model="editedItem.situacao_anoanterior"
                  :v_validate="'positiveNumber'"
                  :data_vv_as="
                    translate('table.' + entity + '.field.situacao_anoanterior') +
                    ($auth.user().anobase.id_texto - 1)
                  "
                ></p-money>
              </v-flex>
              <v-flex xs12 md3>
                <p-money
                  name="situacao_anobase"
                  :label="
                    translate('table.' + entity + '.field.situacao_anobase') +
                    $auth.user().anobase.id_texto
                  "
                  v-model="editedItem.situacao_anobase"
                  :v_validate="'positiveNumber'"
                  :data_vv_as="
                    translate('table.' + entity + '.field.situacao_anobase') +
                    $auth.user().anobase.id_texto
                  "
                ></p-money>
                <div id="proccess">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <!-- <v-btn flat icon color="blue"  class="ma-0"> -->
                      <v-icon v-on="on" @click="processSituacao">refresh</v-icon>
                    </template>
                    <span>
                      Clique aqui para atualizar este campo com base nos valores já lançados.
                    </span>
                  </v-tooltip>
                </div>
              </v-flex>
              <!--FIM------------------- Distribuição ------------------->

              <v-flex xs12>
                <v-switch
                  color="primary"
                  :label="translate('table.' + entity + '.field.ativo')"
                  v-model="editedItem.ativo"
                ></v-switch>
              </v-flex>

              <v-flex xs12>
                <v-btn
                  class="mx-1"
                  color="primary darken-2"
                  :disabled="saving"
                  :loading="saving"
                  @click.native="save(entity, editedItem.id, editedItem, 1, true)"
                >
                  Salvar
                </v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
#sub_items_table {
  border-radius: 4px;
  border: 1px solid #bbb;
  margin-bottom: 4px;
}

#sub_items_table .custom-height {
  padding-top: 8px !important;
}

td .custom-height {
  padding-top: 6px;
  display: flex;
  align-items: center;
}

#proccess {
  position: absolute;
}

#proccess .v-icon {
  position: relative;
  bottom: 50px;
  left: 233px;
}

tr td:last-child {
  min-width: 130px;
}

#unidade {
  position: relative;
  top: -10px;
}
</style>

<script>
import crud from "./../../mixin/crud";
import PDate from "../shared/PDate";
import PCpfCnpj from "../shared/PCpfCnpj";
import mask from "./../../mixin/mask";
import PMoney from "../shared/PMoney";
import Helper from "./../../classes/helper";
import acl from "./../../mixin/acl";

export default {
  components: {
    PDate,
    PMoney,
    PCpfCnpj,
  },
  mixins: [crud, mask, acl],
  data: () => ({
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false /* doesn't work with directive */,
    },
    entity: "condominio_bemdireito",
    subItemTipos: [
      { id: "pagamento", id_texto: "Pagamento/Acréscimo" },
      { id: "liberacao", id_texto: "Alienação/Redução" },
    ],
    items: [],
    temDependente: [],
    pagination: { rowsPerPage: 25, sortBy: "", descending: false },
    page: 1,
    setKeyup: null,
    total_situacao_anobase: 0,
    total_situacao_anoanterior: 0,
    limitarCaracteres: true,
    maxCaracteres: 0,
    sequencia_ir_duplicated: false,
    apenasAtivos: true,
  }),
  name: "BemDireito",
  props: [
    "condominio_id",
    "paises",
    "cidades",
    "initials",
    "dependente_items",
    "particular",
    "item",
  ],
  created() {
    let anobaseId = this.$auth.user().anobase.id;

    this.initialize();

    this.editedItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      unidade: "m2",
      grupo: null,
      codigo: null,
      anobase_id: anobaseId,
      cpf_cnpj: "",
      cpf_cnpj_fornecedor: "",
      cpf_cnpj_adquirente: "",
      valor_adquirente: "0",
      valor_fornecedor: "0",
      pais_id: 105,
      sub_items: [],
      pessoa_dependente_id: null,
      motivo_baixa: null,
      id_texto: "",
      area_imovel: 0,
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      unidade: "m2",
      grupo: null,
      codigo: null,
      anobase_id: anobaseId,
      cpf_cnpj: "",
      cpf_cnpj_fornecedor: "",
      cpf_cnpj_adquirente: "",
      valor_adquirente: "0",
      valor_fornecedor: "0",
      pais_id: 105,
      sub_items: [],
      pessoa_dependente_id: null,
      motivo_baixa: null,
      id_texto: "",
      area_imovel: 0,
    };
  },
  methods: {
    checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    verificarValoresNegativos() {
      // Use some para verificar se pelo menos um item tem valor negativo
      const hasNegativeValue = this.editedItem.sub_items.some((subItem) => subItem.valor < 0);

      // Se tiver algum valor negativo, mostre uma mensagem de erro
      if (hasNegativeValue || this.editedItem.situacao_anobase < 0) {
        this.$store.commit("snackbar/change_values", {
          text: "Por favor, verifique os valores inseridos. Não é permitido informar valores negativos",
          color: "error",
          dialog: true,
          timeout: 5000,
        });
        return false;
      }

      // Se não houver nenhum valor negativo, retorne true
      return true;
    },
    removeMask() {
      // Remove a máscara ao perder o foco
      if (this.item.valor) {
        this.item.valor = this.item.valor.replace(/\D/g, "");
      }
    },
    // The method below returns true if the edited item's text length is greater than the max number of characters.
    afterSave() {
      this.initialize();
    },
    afterDelete() {
      this.initialize();
    },
    beforeSave() {
      // Defina editedItem.motivo_baixa como null se for undefined
      if (typeof this.editedItem.motivo_baixa === "undefined") {
        this.editedItem.motivo_baixa = null;
      }

      // Verifique se há valores negativos
      if (!this.verificarValoresNegativos()) {
        this.$store.commit("loader/change_dialog", false);
        throw new Error("Não é possível salvar devido a valores negativos.");
      }
    },
    initialize() {
      this.$store.commit("loader/change_dialog", true);
      let params = {
        search: this.search,
        apenasAtivos: this.apenasAtivos,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "sequencia_ir",
        condominio_id: this.condominio_id ? this.condominio_id : 0,
      };
      this.$http.post(`api/paginate_bemdireito`, params).then(
        (res) => {
          this.total_situacao_anoanterior = res.body.total_situacao_anoanterior;
          this.total_situacao_anobase = res.body.total_situacao_anobase;
          let resbody = res.body.dados;
          this.items = resbody.data;
          Object.assign(this.pagination, {
            total: resbody.total,
            rowsPerPage: resbody.per_page,
            current_page: resbody.current_page,
            last_page: resbody.last_page,
            from: resbody.from,
            to: resbody.to,
          });
          this.$store.commit("loader/change_dialog", false);
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os dados.",
            color: "error",
            dialog: true,
          });
          this.$store.commit("loader/change_dialog", false);
        }
      );
    },
    keyupSearch(key) {
      // caso o usuario fique 2 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      if (key["key"] === "Enter") {
        this.initialize();
      } else {
        this.setKeyup = setTimeout(() => {
          this.initialize();
        }, 2000);
      }
    },
    changePage(page = 1) {
      this.pagination["current_page"] = page;
      this.initialize();
    },
    beforeCreate() {
      this.$http.post(`api/get_max_sequence_bemdireito/${this.condominio_id}`).then(
        (res) => {
          let maxSequence = res.body;
          maxSequence = Helper.pad(++maxSequence, 5);
          this.editedItem.sequencia_ir = `${
            this.initials ? this.initials + "-" : ""
          }BD-${maxSequence}`;
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar a sequencia.",
            color: "error",
            dialog: true,
          });
        }
      );

      this.$validator.reset();
    },
    afterEdit() {
      this.limitarCaracteres = this.editedItem.id_texto.length <= 150;
      if (typeof this.editedItem.situacao_atual[0] !== "undefined" && this.editedItem.situacao_atual[0] !== null)
        this.editedItem.sub_items = this.editedItem.situacao_atual[0].distribuicoes;
    },
    createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor: 0,
      });
    },
    deleteSubItem(item) {
      const index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao() {
      const { liberacao, pagamento } = this.sum;
      this.editedItem.situacao_anobase =
        this.editedItem.situacao_anoanterior - liberacao + pagamento;
    },
    getGrupoText (value) {
      const item = this.translate('value.bem_direito_grupo').find(g => g.value === value)
      return item ? item.text : ''
    },
    getCodigoText (grupo, codigo) {
      const item = this.translate('value.bem_direito_codigo').find(c => c.grupo === grupo && c.value === codigo)
      return item ? item.text : ''
    },
    // type 1 = pdf 2 = excel
    exportReport (type) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.put(`report/report_details/${this.condominio_id}`, {"type": type, "table": "condominio_bemdireito", "search": this.search, "apenasAtivos": this.apenasAtivos}).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    }
  },
  computed: {
    formattedValue: {
      get() {
        // Retorna o valor formatado com a máscara
        return this.item.valor;
      },
      set(value) {
        // Remove a máscara e atualiza o valor no estado do Vue.js
        this.item.valor = value.replace(/\D/g, "");
      },
    },
    headers() {
      return [
        {
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%",
        },
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "40%",
        },
        {
          text: this.translate("table." + this.entity + ".field.grupo"),
          value: "grupo",
          width: "5%",
        },
        {
          text: this.translate("table." + this.entity + ".field.codigo"),
          value: "codigo",
          width: "5%",
        },
        {
          text:
            this.translate("table." + this.entity + ".field.situacao_anoanterior") +
            (this.$auth.user().anobase.id_texto - 1),
          value: "situacao_anoanterior",
          width: "10%",
          align: "right",
        },
        {
          text:
            this.translate("table." + this.entity + ".field.situacao_anobase") +
            this.$auth.user().anobase.id_texto,
          value: "situacao_anobase",
          width: "10%",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.ativo"),
          value: "ativo",
          width: "5%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
    sub_headers () {
      return [
        {
          text: this.translate("table." + this.entity + "_item.field.tipo"),
          sortable: false,
          value: "tipo",
        },
        {
          text: this.translate("table." + this.entity + "_item.field.data"),
          sortable: false,
          value: "data",
        },
        {
          text: this.translate("table." + this.entity + "_item.field.valor"),
          sortable: false,
          value: "valor",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
    sum() {
      return this.editedItem.sub_items.reduce(
        (acc, cur) => {
          acc[cur.tipo] += cur.valor;
          return acc;
        },
        { pagamento: 0, liberacao: 0 }
      );
    },
  },
  watch: {
    pagination: {
      handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/BemDireito.vue